import * as mutationTypes from './mutation-types'

export default function createQueryModule() {
  return {
    state() {
      return {
        currentQuery: null,
      }
    },

    getters: {
      currentQuery: ({ currentQuery }) => {
        return currentQuery
      },
    },

    mutations: {
      [mutationTypes.SET_CURRENT_QUERY_TEXT](state, newQuery) {
        state.currentQuery = newQuery
      },
    },

    actions: {
      actualUpdateCurrentQuery(
        { commit, dispatch, state, rootState },
        queryValue
      ) {
        // move back to first item if query changes
        if (queryValue !== state.currentQuery) {
          commit(mutationTypes.SET_LAST_SELECTION, false)
        }
        commit(mutationTypes.SET_CURRENT_QUERY_TEXT, queryValue)
        if (!rootState.dataLoaded) {
          dispatch('fetchSearchData', null, { root: true })
        }
      },
      clearCurrentQuery({ commit }) {
        commit(mutationTypes.SET_LAST_SELECTION, false)
        commit(mutationTypes.SET_CURRENT_QUERY_TEXT, '')
      },
    },
  }
}
